import { zodResolver } from "@hookform/resolvers/zod";
import {
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { z } from "zod";
import { useEffect, useState } from "react";
import { AppState, useAppDispatch, useAppSelector } from "../../store";
import { useUsers } from "../../hooks/useUsers";
import { setUserObj, setUserPermissions } from "../../store/slices/commonSlice";
import { AlertDialog } from "../common/AlertDailog";
import { switchRoleSchema } from "../../config/schemas/switchRoleSchema";
import { useSnackbar } from "../../hooks/useSnackbar";
import { useNavigate } from "react-router-dom";

const SwitchRole = (props: any) => {
  const { openSwitchRole, setOpenSwitchRole, setGetUserDetails } = props;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const userObj = useAppSelector(
    (state: AppState) => state.commonSlice.userObj
  );
  const { email, defaultRole } = userObj;
  const { showSuccess } = useSnackbar();
  const [roleOptions, setRoleOptions] = useState([]);
  const {
    switchUser,
    switchRoleSuccess,
    switchRoleData,
    getLoggedInUserRoles,
    loggedInUserRolesData,
  } = useUsers();

  const handleClose = () => {
    setOpenSwitchRole(false);
    reset();
  };
  type FormData = z.infer<typeof switchRoleSchema>;
  const {
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      roles: defaultRole,
    },
    resolver: zodResolver(switchRoleSchema),
  });
  const onInvalid = (errors: any) => console.debug(errors);
  const submit = (data: FormData) => {
    const selectedRoleCode = loggedInUserRolesData?.roles?.find(
      (item: { name: any }) => item.name == data.roles
    );
    switchUser({
      data: {
        email,
        default_role: selectedRoleCode?.code,
      },
    });
  };
  const getSelectedUserDetails = () => {
    getLoggedInUserRoles();
  };

  useEffect(() => {
    if (switchRoleSuccess) {
      getSelectedUserDetails();
      getAllUIPermissions({});
      setGetUserDetails(true);
      handleClose();
      showSuccess(switchRoleData?.details, "user-switch-role-success");
      navigate("/");
    }
  }, [switchRoleSuccess, switchRoleData]);

  const { getAllUIPermissions, uIPermissionData, uIPermissionIsSuccess } =
    useUsers();

  useEffect(() => {
    if (uIPermissionIsSuccess) {
      dispatch(
        setUserPermissions(
          uIPermissionData?.user_permissions?.map((item: any) => item.name)
        )
      );
    }
  }, [uIPermissionData, uIPermissionIsSuccess]);

  useEffect(() => {
    if (openSwitchRole) {
      getSelectedUserDetails();
    }
  }, [openSwitchRole]);

  useEffect(() => {
    if (loggedInUserRolesData) {
      const selectedRole = loggedInUserRolesData?.roles?.find(
        (item: { code: any }) =>
          item.code == loggedInUserRolesData?.default_role
      );
      dispatch(
        setUserObj({
          ...userObj,
          defaultRole: selectedRole?.name,
        })
      );
      setRoleOptions(
        loggedInUserRolesData?.roles?.map((ele: any) => {
          return { name: ele.name, code: ele.code };
        })
      );
    }
  }, [loggedInUserRolesData]);

  return (
    <>
      <AlertDialog
        open={openSwitchRole}
        title="Switch Role"
        handleClose={handleClose}
        handleConfirm={handleSubmit(submit, onInvalid)}
        confirmBtn="Save"
        cancelBtn="Cancel"
        maxWidth="xs"
      >
        <form>
          <Grid item xs={12}>
            <FormControl
              fullWidth
              margin="normal"
              error={!!errors.roles}
              className="labelAlignFix"
            >
              <InputLabel id="roles-label">Choose Role</InputLabel>
              <Controller
                name="roles"
                control={control}
                render={({ field }) => (
                  <Select
                    labelId="roles-label"
                    {...field}
                    variant="standard"
                    label="Choose Role"
                  >
                    {roleOptions?.map((ele: any) => (
                      <MenuItem key={ele.code} value={ele.name}>
                        {ele.name}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
              {errors.roles && (
                <FormHelperText>{errors.roles.message}</FormHelperText>
              )}
            </FormControl>
          </Grid>
        </form>
      </AlertDialog>
    </>
  );
};

export default SwitchRole;
